export default "__VITE_ASSET__BwGe03wd__"